import { Link } from "react-router-dom";
import type { Manga } from "@/mocks/manga";

function Sweetness({ value }: { value: number }) {
  return (
    <span className="flex items-center gap-0.5" title={`甜度 ${value}`}>
      {[1, 2, 3, 4, 5].map((i) => (
        <i
          key={i}
          className={`ri-heart-fill text-[11px] ${value >= i - 0.25 ? "text-accent-500" : "text-background-300"}`}
          aria-hidden="true"
        ></i>
      ))}
    </span>
  );
}

export default function MangaCard({ manga, rank }: { manga: Manga; rank?: number }) {
  return (
    <Link
      to={`/manga/${manga.id}`}
      className="group flex flex-col overflow-hidden rounded-2xl bg-background-50 ring-1 ring-background-200 transition-all duration-300 hover:-translate-y-1 hover:ring-primary-300"
    >
      <div className="relative aspect-[3/4] w-full overflow-hidden bg-background-100">
        <img
          src={manga.cover}
          alt={`${manga.title}漫画封面`}
          loading="lazy"
          className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        {typeof rank === "number" && (
          <span className="absolute left-2 top-2 flex h-6 min-w-6 items-center justify-center rounded-md bg-primary-500 px-1 text-xs font-bold text-background-50">
            {rank}
          </span>
        )}
        <span className="absolute right-2 top-2 rounded-full bg-foreground-950/60 px-2 py-0.5 text-[11px] text-background-50 backdrop-blur-sm">
          {manga.status}
        </span>
      </div>
      <div className="flex flex-1 flex-col p-3">
        <h3 className="truncate text-sm font-medium text-foreground-900">{manga.title}</h3>
        <p className="mt-1 truncate text-xs text-foreground-500">
          {manga.category} · {manga.author}
        </p>
        <div className="mt-2 flex items-center justify-between">
          <Sweetness value={manga.sweetness} />
          <span className="flex items-center gap-1 text-xs text-secondary-700">
            <i className="ri-star-fill text-secondary-500" aria-hidden="true"></i>
            {manga.rating.toFixed(1)}
          </span>
        </div>
        <p className="mt-2 truncate border-t border-background-100 pt-2 text-[11px] text-foreground-400">
          <i className="ri-time-line mr-1" aria-hidden="true"></i>
          {manga.latest}
        </p>
      </div>
    </Link>
  );
}